import { InjectionToken } from '@angular/core';
import { IAscModuleDefinition } from '../i-asc-module-definition';
import { PublicInternetAccessClientModuleConfiguration } from './model/public-internet-access-client-module-configuration';


export const MODULE_CONFIGURATION = new InjectionToken<PublicInternetAccessClientModuleConfiguration>('module configuration');

export const PUBLIC_INTERNET_ACCESS_ROUTE_PATH = {
   CODE: 'code'
};

export const PUBLIC_INTERNET_ACCESS_NAVIGATION_ITEMS = {
   ROOT: 'public-internet-access'
};

export const PUBLIC_INTERNET_ACCESS_DEFINITION: IAscModuleDefinition = {
   moduleId: 'PUBLIC_INTERNET_ACCESS',
   displayName: 'Public Internet Access',
   moduleRoute: {
      path: 'public-internet-access',
      loadChildren: () => import('src/modules/public-internet-access/public-internet-access.module').then(m => m.PublicInternetAccessModule)
   }
};